<cue-declarative-map-marker pane="poi" [zIndexOffset]="activeZIndexOffset" [geoJson]="geoJson()" [focused]="focused()">
  <div
    *cueDeclarativeMapMarkerTemplate
    class="map-target-point-host"
    (click)="onHostClick($event)"
    [style.transform]="'scale(' + scale() + ')'"
    [style.-webkit-transform]="'scale(' + scale() + ')'"
  >
    <div class="target-point">
      @if (targetPoint().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Icon) {
        <img class="map-btn-icon-wrapper" [src]="targetPoint().icon | imageDimensions: { width: 50, height: 50 }" />
      }
      @if (targetPoint().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Image) {
        <img
          class="map-btn-icon-wrapper map-btn-icon-wrapper--img"
          [src]="targetPoint().image | imageDimensions: { height: 50 }"
        />
      }
      @if (targetPoint().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Name) {
        <span class="map-btn-name">{{ targetPoint().name | localizedString }}</span>
      }
      <div
        class="target-point-marker"
        data-cy="navigation-map-target-point"
        [attr.data-qr-code-id]="targetPoint().poi?.qrCodeId"
      >
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.5 1C8.3645 1 5 4.46964 5 8.73438C5 10.1753 5.38704 11.5815 6.11954 12.8015L12.0731 22.6953C12.1871 22.8848 12.388 23 12.6041 23H12.6091C12.827 22.9982 13.0284 22.8795 13.1403 22.6867L18.9421 12.697C19.6342 11.5028 20 10.1325 20 8.73438C20 4.46964 16.6355 1 12.5 1ZM17.8694 12.0351L12.5947 21.1174L7.18196 12.1223C6.57225 11.1069 6.24167 9.93535 6.24167 8.73438C6.24167 5.18043 9.05375 2.28047 12.5 2.28047C15.9462 2.28047 18.7542 5.18043 18.7542 8.73438C18.7542 9.89973 18.4454 11.0413 17.8694 12.0351Z"
            fill="#820B8A"
          />
          <path
            d="M12.5 5C10.5701 5 9 6.5701 9 8.5C9 10.4176 10.5445 12 12.5 12C14.4796 12 16 10.3965 16 8.5C16 6.5701 14.4299 5 12.5 5ZM12.5 10.8411C11.2067 10.8411 10.1589 9.78983 10.1589 8.5C10.1589 7.2134 11.2134 6.15889 12.5 6.15889C13.7866 6.15889 14.8372 7.2134 14.8372 8.5C14.8372 9.77101 13.8138 10.8411 12.5 10.8411Z"
            fill="#820B8A"
          />
        </svg>
      </div>
    </div>
  </div>
</cue-declarative-map-marker>
